// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"742869046e66873c","8707":"1907dcb6f9dc7e20"}[chunkId] + ".css";
};